import React, { useState, useEffect, useContext } from 'react';
import styles from './Header.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiSearch, FiBell } from 'react-icons/fi';
import api from '../utils/api';
import { AuthContext } from '../context/AuthContext';
import Logo from './Logo';

const Header = ({ isDisabled }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const [unreadCount, setUnreadCount] = useState(0);

  const isSearchPage = location.pathname === '/search';

  useEffect(() => {
    const fetchUnreadNotifications = async () => {
      if (!user) return;
      try {
        const res = await api.get('/api/notifications');
        const unread = res.data.filter(n => !n.read).length;
        setUnreadCount(unread);
      } catch (error) {
        console.error('Failed to fetch notifications', error);
      }
    };

    fetchUnreadNotifications();
    const interval = setInterval(fetchUnreadNotifications, 60000);

    return () => clearInterval(interval);
  }, [user]);

  const handleSearchClick = () => {
    navigate('/search');
  };

  const handleNotificationClick = () => {
    navigate('/notifications');
  };

  const headerClassName = `${styles.header} ${isDisabled ? styles['disabled-interaction'] : ''}`;

  return (
    <header className={headerClassName}>
      <div className={styles['header-left']}>
          <Logo size="1.25rem" />
      </div>
      <div className={styles['header-right']}>
        {!isSearchPage && (
          <div className={styles['search-bar-container']} onClick={handleSearchClick} disabled={isDisabled}>
            <FiSearch className={styles['search-icon']} />
            <span className={styles['search-text']}>Search</span>
          </div>
        )}
        <button className={styles['notification-btn']} onClick={handleNotificationClick} disabled={isDisabled}>
          <FiBell />
          {unreadCount > 0 && <span className={styles.badge}>{unreadCount}</span>}
        </button>
      </div>
    </header>
  );
};

export default Header;
